import { __ } from '@wordpress/i18n';
import classnames from 'classnames';

import {
	AlignmentToolbar,
	BlockControls,
	ColorPalette,
	InnerBlocks,
	InspectorControls,
	RichText,
	useBlockProps,
} from '@wordpress/block-editor';

import {
	__experimentalDivider as Divider,
	__experimentalRadio as Radio,
	__experimentalRadioGroup as RadioGroup,
	__experimentalText as Text,
	PanelBody,
	RangeControl,
	SelectControl,
	TabPanel,
	TextControl,
	ToggleControl,
} from '@wordpress/components';
import { useState } from '@wordpress/element';
import './editor.scss';
import { colors } from '../../utils/colors';

const ALLOWED_BLOCKS = ['core/image'];

export default function Edit({ attributes, setAttributes }) {
	const {
		alignment,
		title,
		body,
		btnText1,
		btnText2,
		target,
		borderColor,
		borderWidth,
		borderRadius,
		btnStyleFirst,
		btnStyleSecond,
		btnBackgroundFirst,
		btnBackgroundSecond,
		borderRadiusFirst,
		borderRadiusSecond,
		borderWidthFirst,
		borderWidthSecond,
		btnBorderColorFirst,
		btnBorderColorSecond,
		btnLinkFirst,
		btnLinkSecond,
		btnColorFirst,
		btnColorSecond,
		rel,
		btnHoverBackgroundFirst,
		btnHoverBackgroundSecond,
		btnHoverColorFirst,
		btnHoverColorSecond,
	} = attributes;

	const [btn, setBtn] = useState('first');

	const blockProps = useBlockProps({
		className: 'asl-cta-1',
	});

	const hoverClassFirst =
		(btnHoverBackgroundFirst
			? btnHoverBackgroundFirst.replace('#', '') + '-'
			: '') +
		(btnHoverColorFirst ? btnHoverColorFirst.replace('#', '') : '');

	const hoverClassSecond =
		(btnHoverBackgroundSecond
			? btnHoverBackgroundSecond.replace('#', '') + '-'
			: '') +
		(btnHoverColorSecond ? btnHoverColorSecond.replace('#', '') : '');

	const btnClassStyleFirst =
		btnStyleFirst === 'fill' ? 'asl-fill' : 'asl-outline';
	const btnClassStyleSecond =
		btnStyleSecond === 'fill' ? 'asl-fill' : 'asl-outline';

	const hoverStylesFirst =
		(btnHoverBackgroundFirst
			? `background-color: #${btnHoverBackgroundFirst.replace(
					'#',
					''
			  )}!important;`
			: '') +
		(btnHoverColorFirst
			? `color: #${btnHoverColorFirst.replace('#', '')}!important;`
			: '');

	const hoverStylesSecond =
		(btnHoverBackgroundSecond
			? `background-color: #${btnHoverBackgroundSecond.replace(
					'#',
					''
			  )}!important;`
			: '') +
		(btnHoverColorSecond
			? `color: #${btnHoverColorSecond.replace('#', '')}!important;`
			: '');

	const onSelectFirst = (tabName) => {
		let content;
		if (tabName.name === 'current') {
			if (btnStyleFirst === 'fill') {
				content = (
					<>
						<Text
							size={14}
							weight={400}
							display={'block'}
							style={{ marginBottom: 10 }}
						>
							{__('Background color:', 'asl-blocks')}
						</Text>
						<ColorPalette
							value={btnBackgroundFirst}
							colors={colors}
							onChange={(color) =>
								setAttributes({
									btnBackgroundFirst: color,
								})
							}
						/>

						<Text
							size={14}
							weight={400}
							display={'block'}
							style={{ marginBottom: 10 }}
						>
							{__('Text color:', 'asl-blocks')}
						</Text>
						<ColorPalette
							value={btnColorFirst}
							colors={colors}
							onChange={(color) =>
								setAttributes({ btnColorFirst: color })
							}
						/>
					</>
				);
			} else {
				content = (
					<>
						<Text
							size={14}
							weight={400}
							display={'block'}
							style={{ marginBottom: 10 }}
						>
							{__('Border width:', 'asl-blocks')}
						</Text>
						<RangeControl
							value={borderWidthFirst}
							onChange={(width) =>
								setAttributes({ borderWidthFirst: width })
							}
							min={0}
							max={10}
							step={1}
						/>
						<Text
							size={14}
							weight={400}
							display={'block'}
							style={{ marginBottom: 10 }}
						>
							{__('Border color:', 'asl-blocks')}
						</Text>
						<ColorPalette
							value={btnBorderColorFirst}
							colors={colors}
							onChange={(color) =>
								setAttributes({
									btnBorderColorFirst: color,
								})
							}
						/>
						<Text
							size={14}
							weight={400}
							display={'block'}
							style={{ marginBottom: 10 }}
						>
							{__('Text color:', 'asl-blocks')}
						</Text>
						<ColorPalette
							value={btnColorFirst}
							onChange={(val) =>
								setAttributes({
									btnColorFirst: val,
								})
							}
						/>
					</>
				);
			}
		} else {
			content = (
				<>
					<Text
						size={14}
						weight={400}
						display={'block'}
						style={{ marginBottom: 10 }}
					>
						{__('Background hover color:', 'asl-blocks')}
					</Text>
					<ColorPalette
						value={btnHoverBackgroundFirst}
						onChange={(color) =>
							setAttributes({ btnHoverBackgroundFirst: color })
						}
					/>

					<Text
						size={14}
						weight={400}
						display={'block'}
						style={{ marginBottom: 10 }}
					>
						{__('Text hover color:', 'asl-blocks')}
					</Text>
					<ColorPalette
						value={btnHoverColorFirst}
						onChange={(color) =>
							setAttributes({ btnHoverColorFirst: color })
						}
					/>
				</>
			);
		}

		return content;
	};

	const onSelectSecond = (tabName) => {
		let content;
		if (tabName.name === 'current') {
			if (btnStyleSecond === 'fill') {
				content = (
					<>
						<Text
							size={14}
							weight={400}
							display={'block'}
							style={{ marginBottom: 10 }}
						>
							{__('Background color:', 'asl-blocks')}
						</Text>
						<ColorPalette
							value={btnBackgroundSecond}
							colors={colors}
							onChange={(color) =>
								setAttributes({
									btnBackgroundSecond: color,
								})
							}
						/>

						<Text
							size={14}
							weight={400}
							display={'block'}
							style={{ marginBottom: 10 }}
						>
							{__('Text color:', 'asl-blocks')}
						</Text>
						<ColorPalette
							value={btnColorSecond}
							colors={colors}
							onChange={(color) =>
								setAttributes({ btnColorSecond: color })
							}
						/>
					</>
				);
			} else {
				content = (
					<>
						<Text
							size={14}
							weight={400}
							display={'block'}
							style={{ marginBottom: 10 }}
						>
							{__('Border width:', 'asl-blocks')}
						</Text>
						<RangeControl
							value={borderWidthSecond}
							onChange={(width) =>
								setAttributes({ borderWidthSecond: width })
							}
							min={0}
							max={10}
							step={1}
						/>

						<Text
							size={14}
							weight={400}
							display={'block'}
							style={{ marginBottom: 10 }}
						>
							{__('Border color:', 'asl-blocks')}
						</Text>
						<ColorPalette
							value={btnBorderColorSecond}
							colors={colors}
							onChange={(color) =>
								setAttributes({
									btnBorderColorSecond: color,
								})
							}
						/>
						<Text
							size={14}
							weight={400}
							display={'block'}
							style={{ marginBottom: 10 }}
						>
							{__('Text color:', 'asl-blocks')}
						</Text>
						<ColorPalette
							value={btnColorSecond}
							colors={colors}
							onChange={(val) =>
								setAttributes({
									btnColorSecond: val,
								})
							}
						/>
					</>
				);
			}
		} else {
			content = (
				<>
					<Text
						size={14}
						weight={400}
						display={'block'}
						style={{ marginBottom: 10 }}
					>
						{__('Background hover color:', 'asl-blocks')}
					</Text>
					<ColorPalette
						value={btnHoverBackgroundSecond}
						colors={colors}
						onChange={(color) =>
							setAttributes({ btnHoverBackgroundSecond: color })
						}
					/>

					<Text
						size={14}
						weight={400}
						display={'block'}
						style={{ marginBottom: 10 }}
					>
						{__('Text hover color:', 'asl-blocks')}
					</Text>
					<ColorPalette
						value={btnHoverColorSecond}
						colors={colors}
						onChange={(color) =>
							setAttributes({ btnHoverColorSecond: color })
						}
					/>
				</>
			);
		}
		return content;
	};

	return (
		<>
			<InspectorControls style={{ marginBottom: '40px' }}>
				<PanelBody title={__('Border template settings', 'asl-blocks')}>
					<Text
						size={14}
						weight={400}
						display={'block'}
						style={{ marginBottom: 10 }}
					>
						{__('Select a border color:', 'asl-blocks')}
					</Text>
					<ColorPalette
						value={borderColor}
						colors={colors}
						onChange={(color) =>
							setAttributes({ borderColor: color })
						}
					/>
					<Text
						size={14}
						weight={400}
						display={'block'}
						style={{ marginBottom: 10 }}
					>
						{__('Select a border width:', 'asl-blocks')}
					</Text>
					<RangeControl
						value={borderWidth}
						onChange={(width) =>
							setAttributes({ borderWidth: width })
						}
						min={0}
						max={15}
						step={1}
					/>
					<Text
						size={14}
						weight={400}
						display={'block'}
						style={{ marginBottom: 10 }}
					>
						{__('Select a border radius:', 'asl-blocks')}
					</Text>
					<RangeControl
						value={borderRadius}
						onChange={(radius) =>
							setAttributes({ borderRadius: radius })
						}
						min={0}
						max={50}
						step={1}
					/>
				</PanelBody>
				<PanelBody title={__('Global links settings', 'asl-blocks')}>
					<ToggleControl
						label={__('Open in new window:', 'asl-blocks')}
						checked={target}
						onChange={(state) => {
							setAttributes({ target: state });
						}}
					/>
					<Text
						size={14}
						weight={400}
						display={'block'}
						style={{ marginBottom: 10 }}
					>
						{__('Add a rel attributes:', 'asl-blocks')}
					</Text>
					<TextControl
						value={rel}
						onChange={(newRel) => setAttributes({ rel: newRel })}
					/>
				</PanelBody>
				<PanelBody title={__('Buttons settings', 'asl-blocks')}>
					<Text
						size={14}
						weight={400}
						display={'block'}
						style={{ marginBottom: 10 }}
					>
						{__('Select button:', 'asl-blocks')}
					</Text>
					<RadioGroup
						onChange={setBtn}
						checked={btn}
						className="range-flex"
					>
						<Radio value="first" className="range-flex">
							{__('First Button')}
						</Radio>
						<Radio value="second" className="range-flex">
							{__('Second Button')}
						</Radio>
					</RadioGroup>

					{btn === 'first' && (
						<>
							<Text
								size={15}
								weight={500}
								display={'block'}
								style={{ marginBottom: 10 }}
							>
								{__('First button settings:', 'asl-blocks')}
							</Text>
							<Divider />
							<TextControl
								label={__('Add link:', 'asl-blocks')}
								value={btnLinkFirst}
								onChange={(link) =>
									setAttributes({ btnLinkFirst: link })
								}
							/>

							<RangeControl
								label={__('Border radius:', 'asl-blocks')}
								value={borderRadiusFirst}
								onChange={(radius) =>
									setAttributes({ borderRadiusFirst: radius })
								}
								min={0}
								max={50}
								step={1}
							/>

							<Text
								size={14}
								weight={400}
								display={'block'}
								style={{ marginBottom: 10 }}
							>
								{__('Button style:', 'asl-blocks')}
							</Text>
							<SelectControl
								value={btnStyleFirst}
								options={[
									{
										label: __('Fill', 'asl-blocks'),
										value: 'fill',
									},
									{
										label: __('Outline', 'asl-blocks'),
										value: 'outline',
									},
								]}
								onChange={(option) =>
									setAttributes({ btnStyleFirst: option })
								}
							/>
							<Divider />

							<Text
								size={15}
								weight={500}
								display={'block'}
								style={{ marginBottom: 10 }}
							>
								{__('Color settings:', 'asl-blocks')}
							</Text>
							<TabPanel
								activeClass="is-active"
								tabs={[
									{
										name: 'current',
										title: __('Current', 'asl-blocks'),
										className: 'tab-one',
									},
									{
										name: 'hover',
										title: __('Hover', 'asl-blocks'),
										className: 'tab-two',
									},
								]}
							>
								{(tab) => onSelectFirst(tab)}
							</TabPanel>
						</>
					)}

					{btn === 'second' && (
						<>
							<Text
								size={15}
								weight={500}
								display={'block'}
								style={{ marginBottom: 10 }}
							>
								{__('Second button settings:', 'asl-blocks')}
							</Text>
							<Divider />
							<TextControl
								label={__('Add link:', 'asl-blocks')}
								value={btnLinkSecond}
								onChange={(link) =>
									setAttributes({ btnLinkSecond: link })
								}
							/>

							<RangeControl
								label={__('Border radius:', 'asl-blocks')}
								value={borderRadiusSecond}
								onChange={(radius) =>
									setAttributes({
										borderRadiusSecond: radius,
									})
								}
								min={0}
								max={50}
								step={1}
							/>

							<Text
								size={14}
								weight={400}
								display={'block'}
								style={{ marginBottom: 10 }}
							>
								{__('Button style:', 'asl-blocks')}
							</Text>
							<SelectControl
								value={btnStyleSecond}
								options={[
									{
										label: __('Fill', 'asl-blocks'),
										value: 'fill',
									},
									{
										label: __('Outline', 'asl-blocks'),
										value: 'outline',
									},
								]}
								onChange={(option) =>
									setAttributes({ btnStyleSecond: option })
								}
							/>
							<Divider />
							<Text
								size={15}
								weight={500}
								display={'block'}
								style={{ marginBottom: 10 }}
							>
								{__('Color settings:', 'asl-blocks')}
							</Text>
							<TabPanel
								activeClass="is-active"
								tabs={[
									{
										name: 'current',
										title: __('Current', 'asl-blocks'),
										className: 'tab-one',
									},
									{
										name: 'hover',
										title: __('Hover', 'asl-blocks'),
										className: 'tab-two',
									},
								]}
							>
								{(tab) => onSelectSecond(tab)}
							</TabPanel>
						</>
					)}
				</PanelBody>
			</InspectorControls>
			<div
				{...blockProps}
				style={{
					borderColor,
					borderWidth,
					borderRadius,
				}}
			>
				{(hoverClassFirst || hoverClassSecond) && (
					<style
						dangerouslySetInnerHTML={{
							__html: `.asl-cta-1-buttons  .hover-${hoverClassFirst}:hover{${hoverStylesFirst}}.asl-cta-1-buttons .hover-${hoverClassSecond}:hover{${hoverStylesSecond}}`,
						}}
					/>
				)}

				<BlockControls>
					<AlignmentToolbar
						value={alignment}
						onChange={(val) =>
							setAttributes({
								alignment: val === undefined ? 'none' : val,
							})
						}
					/>
				</BlockControls>
				<InnerBlocks allowedBlocks={ALLOWED_BLOCKS} />
				<RichText
					tagName="h3"
					placeholder={__('Your CTA Title', 'asl-blocks')}
					value={title}
					allowedFormats={['core/italic']}
					onChange={(newTitle) => setAttributes({ title: newTitle })}
					style={{ textAlign: alignment }}
				/>

				<div className="asl-cta-1-buttons">
					<RichText
						tagName="a"
						value={btnText1}
						allowedFormats={['core/italic']}
						style={
							btnStyleFirst === 'fill'
								? {
										color: btnColorFirst,
										backgroundColor: btnBackgroundFirst,
										borderRadius: borderRadiusFirst,
								  }
								: {
										borderWidth: borderWidthFirst,
										borderColor: btnBorderColorFirst,
										borderStyle: 'solid',
										color: btnColorFirst,
										borderRadius: borderRadiusFirst,
								  }
						}
						target={target === true ? '_blank' : '_self'}
						href={btnLinkFirst}
						rel={rel}
						onChange={(text) => setAttributes({ btnText1: text })}
						placeholder={__('Type text here', 'asl-blocks')}
						className={classnames(
							'asl-btn-cta-1 asl-btn-first',
							`hover-${hoverClassFirst}`,
							{
								'has-background': btnBackgroundFirst,
								'has-text-color': btnColorFirst,
								[btnClassStyleFirst]: btnClassStyleFirst,
							}
						)}
					/>
					<RichText
						tagName="a"
						value={btnText2}
						allowedFormats={['core/italic']}
						style={
							btnStyleSecond === 'fill'
								? {
										color: btnColorSecond,
										backgroundColor: btnBackgroundSecond,
										borderRadius: borderRadiusSecond,
								  }
								: {
										borderWidth: borderWidthSecond,
										borderColor: btnBorderColorSecond,
										borderStyle: 'solid',
										color: btnColorSecond,
										borderRadius: borderRadiusSecond,
								  }
						}
						target={target === true ? '_blank' : '_self'}
						href={btnLinkSecond}
						rel={rel}
						onChange={(text) => setAttributes({ btnText2: text })}
						placeholder={__('Type text here', 'asl-blocks')}
						className={classnames(
							'asl-btn-cta-1 asl-btn-second',
							`hover-${hoverClassSecond}`,
							{
								'has-background': btnBackgroundSecond,
								'has-text-color': btnColorSecond,
								[btnClassStyleSecond]: btnClassStyleSecond,
							}
						)}
					/>
				</div>

				<RichText
					tagName="div"
					className="asl-cta-1-content"
					allowedFormats={['core/italic']}
					multiline="p"
					placeholder={__('Your CTA Description', 'asl-blocks')}
					value={body}
					onChange={(newBody) => setAttributes({ body: newBody })}
				/>
			</div>
		</>
	);
}
